import { defineMessages, type MessageDescriptor } from 'react-intl-next';

const messages: Record<
	| 'inferredProject'
	| 'inferredProjectTrigger'
	| 'loading'
	| 'loadError'
	| 'suggestedOwner'
	| 'suggestedCollaborators'
	| 'suggestedRecentWork'
	| 'noSuggestedOwner'
	| 'noSuggestedCollaborators'
	| 'noSuggestedRecentWork',
	MessageDescriptor
> = defineMessages({
	inferredProject: {
		defaultMessage: 'Inferred project',
		description: 'Label shown on the inline inferred project chip',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.inferredProject',
	},
	inferredProjectTrigger: {
		defaultMessage: '{projectName}: Inferred project',
		description: 'Accessible label for the inferred project chip trigger',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.inferredProjectTrigger',
	},
	loading: {
		defaultMessage: 'Loading project details',
		description: 'Status shown while inferred project details load',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.loading',
	},
	loadError: {
		defaultMessage: 'Project details could not be loaded.',
		description: 'Error shown when inferred project details fail to load',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.loadError',
	},
	suggestedOwner: {
		defaultMessage: 'Suggested owner',
		description: 'Heading for the inferred project owner section',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.suggestedOwner',
	},
	suggestedCollaborators: {
		defaultMessage: 'Suggested collaborators',
		description: 'Heading for the inferred project collaborators section',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.suggestedCollaborators',
	},
	suggestedRecentWork: {
		defaultMessage: 'Suggested recent work',
		description: 'Heading for the inferred project linked work section',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.suggestedRecentWork',
	},
	noSuggestedOwner: {
		defaultMessage: 'No suggested owner',
		description: 'Empty state for the inferred project owner section',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.noSuggestedOwner',
	},
	noSuggestedCollaborators: {
		defaultMessage: 'No suggested collaborators',
		description: 'Empty state for the inferred project collaborators section',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.noSuggestedCollaborators',
	},
	noSuggestedRecentWork: {
		defaultMessage: 'No suggested recent work',
		description: 'Empty state for the inferred project linked work section',
		id: 'rovo-platform-ui-components.inferred-project-card.inferredProjectCardMessages.noSuggestedRecentWork',
	},
});

export default messages;
